import {
  HardwareQuoteStatus,
  QuoteResponse as QuoteDto,
  QuoteLineItemResponse as QuoteLineItemDto,
} from '@electricjs/core_entity-client';

const commonAddress = {
  street_1: '915 Broadway',
  street_2: 'Suite 802',
  city: 'New York',
  state: 'NY',
  country: 'US',
  zip_code: '10010',
};

const lineItem1: QuoteLineItemDto = {
  id: 'line-item-id-1',
  quote_id: '',
  product_id: 'product-id-thinkpad',
  product: { name: 'Lenovo ThinkPad X1 - Intel Core i7 - 16GB RAM - 1TB SSD' },
  unit_estimated_price: 2199.0,
  is_available: true,
  original_quote_line_item_id: undefined,
};

const lineItem2: QuoteLineItemDto = {
  id: 'line-item-id-2',
  quote_id: '',
  product_id: 'product-id-laptop',
  product: { name: 'MacBook Pro 14 - M3 Pro - 18GB RAM - 512GB SSD' },
  unit_estimated_price: 3999.0,
  is_available: true,
  original_quote_line_item_id: undefined,
};

const lineItem3: QuoteLineItemDto = {
  id: 'line-item-id-3',
  quote_id: '',
  product_id: 'product-id-xps1',
  product: { name: 'Dell XPS 15 - Intel Core i7 - 16GB RAM - 1TB SSD' },
  unit_price: 2099.0,
  is_available: true,
  original_quote_line_item_id: undefined,
};

const lineItem4: QuoteLineItemDto = {
  id: 'line-item-id-4',
  quote_id: '',
  product_id: 'product-id-xps2',
  product: { name: 'Dell XPS 15 - Intel Core i7 - 32GB RAM - 1TB SSD' },
  unit_price: 2299.0,
  is_available: true,
  original_quote_line_item_id: undefined,
};

export const quotes: QuoteDto[] = [
  // PENDING - just created, no pricing yet
  {
    id: 'quote-id-1',
    friendly_id: 'QTE-0001',
    organization_id: 'org-id-1',
    status: HardwareQuoteStatus.Pending,
    quote_vendor: '',
    requester_user_id: 'user-id-1',
    requester_employee: { id: 'employee-id-1', name: 'Jane Doe' },
    for_employee_id: 'employee-id-2',
    for_employee: { id: 'employee-id-2', name: 'Alice Smith' },
    ship_to_address_id: 'address-id-1',
    ship_to_address: commonAddress,
    recipient_national_id: '123-45-6789',
    recipient_phone_number: '5551234567',
    recipient_email: 'alice.smith@company.com',
    created_at: '2026-04-28T10:00:00Z',
    quote_line_items: [{ ...lineItem1 }, { ...lineItem2 }],
  },

  // QUOTED - received pricing from vendor
  {
    id: 'quote-id-2',
    friendly_id: 'QTE-0002',
    organization_id: 'org-id-1',
    status: HardwareQuoteStatus.Quoted,
    quote_vendor: '',
    requester_user_id: 'user-id-1',
    requester_employee: { id: 'employee-id-1', name: 'Jane Doe' },
    for_employee_id: 'employee-id-3',
    for_employee: { id: 'employee-id-3', name: 'Bob Johnson' },
    ship_to_address_id: 'address-id-1',
    ship_to_address: commonAddress,
    recipient_national_id: '987-65-4321',
    recipient_phone_number: '5559876543',
    recipient_email: 'bob.johnson@company.com',
    created_at: '2026-04-20T09:00:00Z',
    quoted_at: '2026-04-22T14:30:00Z',
    expires_at: '2026-05-22T14:30:00Z',
    min_lead_time: 5,
    max_lead_time: 10,
    quote_line_items: [
      { ...lineItem1, unit_price: 2200.0 },
      { ...lineItem2, unit_price: 4000.0 },
    ],
  },

  // ACCEPTED - client accepted the quote
  {
    id: 'quote-id-3',
    friendly_id: 'QTE-0003',
    organization_id: 'org-id-1',
    status: HardwareQuoteStatus.Accepted,
    quote_vendor: '',
    requester_user_id: 'user-id-2',
    requester_employee: { id: 'employee-id-4', name: 'Carol Williams' },
    for_employee_id: 'employee-id-5',
    for_employee: { id: 'employee-id-5', name: 'David Brown' },
    ship_to_address_id: 'address-id-2',
    ship_to_address: {
      ...commonAddress,
      street_1: '350 5th Ave',
      city: 'New York',
      zip_code: '10118',
    },
    recipient_national_id: '555-12-3456',
    recipient_phone_number: '5550001111',
    recipient_email: 'david.brown@company.com',
    created_at: '2026-04-10T08:00:00Z',
    quoted_at: '2026-04-12T11:00:00Z',
    expires_at: '2026-05-12T11:00:00Z',
    accepted_at: '2026-04-15T16:00:00Z',
    accepted_by_user_id: 'user-id-2',
    min_lead_time: 3,
    max_lead_time: 7,
    order: { friendly_id: 'friendly-id-1' },
    order_id: 'order-id-1',
    quote_line_items: [
      { ...lineItem1, unit_price: 2200.0 },
      { ...lineItem2, unit_price: 4000.0 },
    ],
  },

  // REJECTED - user rejected the finalized quote
  {
    id: 'quote-id-4',
    friendly_id: 'QTE-0004',
    organization_id: 'org-id-1',
    status: HardwareQuoteStatus.Rejected,
    quote_vendor: '',
    requester_user_id: 'user-id-1',
    requester_employee: { id: 'employee-id-1', name: 'Jane Doe' },
    for_employee_id: 'employee-id-6',
    for_employee: { id: 'employee-id-6', name: 'Eva Martinez' },
    ship_to_address_id: 'address-id-1',
    ship_to_address: commonAddress,
    recipient_national_id: '444-33-2222',
    recipient_phone_number: '5554443333',
    recipient_email: 'eva.martinez@company.com',
    created_at: '2026-03-25T10:00:00Z',
    quoted_at: '2026-03-27T13:00:00Z',
    expires_at: '2026-04-27T13:00:00Z',
    rejected_at: '2026-03-30T09:00:00Z',
    rejected_by_user_id: 'user-id-1',
    rejected_by_employee: { id: 'employee-id-1', name: 'Jane Doe' },
    reason_for_rejection: 'Price is too high compared to market rates.',
    min_lead_time: 7,
    max_lead_time: 14,
    quote_line_items: [
      { ...lineItem1, unit_price: 4200.0 },
      { ...lineItem2, unit_price: 5000.0 },
    ],
  },

  // EXPIRED - not confirmed within the deadline
  {
    id: 'quote-id-5',
    friendly_id: 'QTE-0005',
    organization_id: 'org-id-1',
    status: HardwareQuoteStatus.Expired,
    quote_vendor: '',
    requester_user_id: 'user-id-3',
    requester_employee: { id: 'employee-id-7', name: 'Frank Garcia' },
    for_employee_id: 'employee-id-8',
    for_employee: { id: 'employee-id-8', name: 'Grace Lee' },
    ship_to_address_id: 'address-id-3',
    ship_to_address: {
      ...commonAddress,
      street_1: '1 Market St',
      city: 'San Francisco',
      state: 'CA',
      zip_code: '94105',
    },
    recipient_national_id: '111-22-3333',
    recipient_phone_number: '4155550000',
    recipient_email: 'grace.lee@company.com',
    created_at: '2026-02-01T08:00:00Z',
    quoted_at: '2026-02-03T10:00:00Z',
    expires_at: '2026-03-03T10:00:00Z',
    min_lead_time: 5,
    max_lead_time: 12,
    quote_line_items: [
      { ...lineItem1, unit_price: 2200.0 },
      { ...lineItem2, unit_price: 4000.0 },
    ],
  },

  // CANCELED - user canceled the quote
  {
    id: 'quote-id-6',
    friendly_id: 'QTE-0006',
    organization_id: 'org-id-1',
    status: HardwareQuoteStatus.Canceled,
    quote_vendor: '',
    requester_user_id: 'user-id-1',
    requester_employee: { id: 'employee-id-1', name: 'Jane Doe' },
    for_employee_id: 'employee-id-9',
    for_employee: { id: 'employee-id-9', name: 'Henry Wilson' },
    ship_to_address_id: 'address-id-1',
    ship_to_address: commonAddress,
    recipient_national_id: '777-88-9999',
    recipient_phone_number: '5557778888',
    recipient_email: 'henry.wilson@company.com',
    created_at: '2026-04-01T08:00:00Z',
    cancelled_at: '2026-04-05T12:00:00Z',
    canceled_by_user_id: 'user-id-1',
    canceled_by_employee: { id: 'employee-id-1', name: 'Jane Doe' },
    reason_for_cancellation:
      'Employee left the company before the quote was processed.',
    quote_line_items: [
      { ...lineItem1, unit_price: 2200.0 },
      { ...lineItem2, unit_price: 4000.0 },
    ],
  },

  // QUOTED - with substitution
  {
    id: 'quote-id-7',
    friendly_id: 'QTE-0007',
    organization_id: 'org-id-1',
    status: HardwareQuoteStatus.Quoted,
    quote_vendor: '',
    requester_user_id: 'user-id-1',
    requester_employee: { id: 'employee-id-1', name: 'Jane Doe' },
    for_employee_id: 'employee-id-3',
    for_employee: { id: 'employee-id-3', name: 'Bob Johnson' },
    ship_to_address_id: 'address-id-1',
    ship_to_address: commonAddress,
    recipient_national_id: '987-65-4321',
    recipient_phone_number: '5559876543',
    recipient_email: 'bob.johnson@company.com',
    created_at: '2026-04-20T09:00:00Z',
    quoted_at: '2026-04-22T14:30:00Z',
    expires_at: '2026-05-22T14:30:00Z',
    min_lead_time: 5,
    max_lead_time: 10,
    quote_line_items: [
      {
        ...lineItem1,
        unit_price: undefined,
        is_available: false,
      },
      { ...lineItem2, unit_price: 4000.0 },
      { ...lineItem3, original_quote_line_item_id: 'line-item-id-1' },
      { ...lineItem4, original_quote_line_item_id: 'line-item-id-1' },
    ],
  },
];
